import FieldContainer from '@shared/components/core/field/FieldContainer';
import StyledTextField from '@shared/components/core/field/StyledTextField';
import LocalizationLanguageField from '@shared/components/localization/LocalizationLanguageField';
import ProfileEditPageContent from '@shared/components/profile/pageContent/ProfileEditPageContent';
import { DefaultVoiceLocale } from '@shared/constants/localization/LocalizationConstants';
import { extractRoleProperties } from '@shared/hooks/helpers/OrganizationalHelpers';
import EditProfileContainer from '@shared/hooks/state/EditProfileContainer';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

const OrgProfileEditPage: React.FC = () => {
    const { t } = useTranslation();
    const editProfileContainer = EditProfileContainer.useContainer();
    const { membership } = useCurrentOrgDetailsFetching();
    const headerTextFieldRef = useRef(null);

    const myRole = membership ? extractRoleProperties(membership) : undefined;

    // TODO text validation but not checking against all profiles

    // TODO add modified version of associated programs editor for org profiles
    // TODO check scroll to for all errors
    // TODO add error validation messaging

    // TODO figure out how to handle device custom controls might need a new container

    return (
        <>
            <FieldContainer>
                <LocalizationLanguageField
                    variant={'voice'}
                    value={editProfileContainer.defaultLocale || DefaultVoiceLocale}
                    onChange={editProfileContainer.handleLocaleChange}
                />
            </FieldContainer>
            <FieldContainer>
                <StyledTextField
                    fullWidth
                    label={t('common:profile.name')}
                    value={editProfileContainer.name}
                    placeholder={t('common:profile.nameQuestion')}
                    onChange={(e) => {
                        editProfileContainer.updateName(e.target.value);
                        editProfileContainer.setHasChanges(true);
                    }}
                    ref={headerTextFieldRef}
                />
            </FieldContainer>

            <FieldContainer>
                <StyledTextField
                    fullWidth
                    multiline
                    rows={3}
                    label={t('common:description')}
                    value={editProfileContainer.description || ''}
                    placeholder={t('common:description')}
                    onChange={(e) => {
                        editProfileContainer.updateDescription(e.target.value);
                        editProfileContainer.setHasChanges(true);
                    }}
                />
            </FieldContainer>

            <ProfileEditPageContent />
        </>
    );
};

export default OrgProfileEditPage;
